import { Check, Lock, Plus } from "lucide-react";
import { SERVICE_IMAGES } from "@/lib/constants";

export const ServiceCard = ({ service, selected, disabled, onToggle }) => {
  const img = SERVICE_IMAGES[service.id];
  return (
    <button
      type="button"
      onClick={() => onToggle(service)}
      disabled={disabled && !selected}
      data-testid={`service-card-${service.id}`}
      aria-pressed={selected}
      className={`hg-card group relative flex h-full flex-col border-2 text-left ${
        selected
          ? "border-[#9D4CDD] bg-[#9D4CDD]/5"
          : "border-black bg-white"
      } ${
        disabled && !selected
          ? "opacity-40 cursor-not-allowed"
          : "cursor-pointer hover:border-[#9D4CDD]"
      }`}
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden border-b-2 border-black bg-[#F4F4F5]">
        {img ? (
          <img
            src={img}
            alt={service.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
          />
        ) : null}

        <div className="absolute left-0 top-0 m-3 border-2 border-black bg-white px-2 py-1">
          <span
            data-testid={`service-price-${service.id}`}
            className="font-display text-sm font-black tracking-tight text-black"
          >
            £{service.price.toLocaleString()}
          </span>
        </div>

        {selected && (
          <div className="absolute right-0 top-0 m-3 inline-flex h-9 w-9 items-center justify-center border-2 border-black bg-[#9D4CDD]">
            <Check className="h-5 w-5 text-white" strokeWidth={3} />
          </div>
        )}
        {disabled && !selected && (
          <div className="absolute right-0 top-0 m-3 inline-flex h-9 w-9 items-center justify-center border-2 border-black bg-white">
            <Lock className="h-4 w-4 text-black" strokeWidth={2.5} />
          </div>
        )}
      </div>

      <div className="flex flex-1 flex-col justify-between gap-4 p-4 md:p-5">
        <h3
          data-testid={`service-name-${service.id}`}
          className="font-display text-lg font-bold leading-tight tracking-tight text-black"
        >
          {service.name}
        </h3>
        <div
          className={`inline-flex items-center gap-2 font-display text-xs font-bold uppercase tracking-[0.2em] ${
            selected ? "text-[#9D4CDD]" : "text-black"
          }`}
        >
          {selected ? (
            <>
              <Check className="h-3.5 w-3.5" strokeWidth={3} /> Added
            </>
          ) : disabled ? (
            <>
              <Lock className="h-3.5 w-3.5" strokeWidth={2.5} /> Over budget
            </>
          ) : (
            <>
              <Plus className="h-3.5 w-3.5" strokeWidth={3} /> Add to list
            </>
          )}
        </div>
      </div>
    </button>
  );
};
